var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12 offset-xs-0 text-center"},[_c('article',{staticClass:"bigger text-center"},[_vm._t("main-heading"),_vm._t("mini-heading"),_c('div',{staticClass:"empty-space h45-md h25-xs"})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }